<template>
    <account-common>
        <div class="mc-content">
            <div class="account-header">
                <ul>
                    <li class="active">修改密码</li>
                </ul>
            </div>
            <div class="account-body">
                <el-form autocomplete="off" :model="registerForm" :rules="rules" ref="registerForm">
                    <el-form-item prop="oldPassword">
                        <el-input v-model="registerForm.oldPassword" type="password" placeholder="请输入原登录密码" @focus="accountInput('oldPassword', 'focus')" @blur="accountInput('oldPassword', 'blur')" class="account-input" :class="inputFocus.oldPassword == true ? 'account-input-focus':''">
                            <template slot="prepend">
                                <i class="iconfont icon-mima account-icon"></i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input v-model="registerForm.password" show-password placeholder="请输入新的8-20位登录密码" @focus="accountInput('password', 'focus')" @blur="accountInput('password', 'blur')" class="account-input" :class="inputFocus.password == true ? 'account-input-focus':''">
                            <template slot="prepend">
                                <i class="iconfont icon-mima account-icon"></i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="confirmPassword">
                        <el-input v-model="registerForm.confirmPassword" show-password placeholder="请再次输入新密码" @focus="accountInput('confirmPassword', 'focus')" @blur="accountInput('confirmPassword', 'blur')" class="account-input" :class="inputFocus.confirmPassword == true ? 'account-input-focus':''">
                            <template slot="prepend">
                                <i class="iconfont icon-mima1 account-icon"></i>
                            </template>
                        </el-input>
                    </el-form-item>
                    <el-form-item class="btn-form-item">
                        <el-button type="primary" @click="onSubmit('registerForm')" class="account-btn" :loading="submitLoading">确认修改</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </account-common>
</template>

<script>
    import accountCommon from '../common/Common';
    export default {
        name: "password",
        components: {
            accountCommon
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (!/[a-zA-Z]+(?=\d+)|\d+(?=[a-zA-Z]+)/.test(value)) {
                    callback(new Error('至少8位且必须包含字母和数字'));
                } else {
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.registerForm.password) {
                    callback(new Error('两次输入密码不一致'));
                } else {
                    callback();
                }
            };
            var validateTelephone = (rule, value, callback) => {
                if (!/^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/.test(value)) {
                    callback(new Error('请输入11位手机号码'));
                }else {
                    callback();
                }
            };
            return {
                loading: false,
                submitLoading: false,
                captchaBoxVisible: false,
                inputFocus: {
                    username: false,
                    oldPassword: false,
                    password: false,
                    smsCode: false,
                    confirmPassword: false
                },
                registerForm: {
                    username: '',
                    oldPassword: '',
                    password: '',
                    confirmPassword: '',
                    smsCode: '',
                    sendSmsBtn: 1,
                    suggest: false,
                    smsTime: 0
                },
                rules: {
                    username: [
                        { required: true, message: '请输入手机号码', trigger: ['change', 'blur'] },
                        { min: 11, max: 11, message: '请输入11位手机号码', trigger: ['change', 'blur'] },
                        { validator: validateTelephone, trigger: ['change', 'blur'] },
                    ],
                    smsCode: [
                        { required: true, message: '请输入6位验证码', trigger: ['change', 'blur'] },
                        { min: 6, max: 6, message: '请输入6位验证码', trigger: ['change', 'blur'] }
                    ],
                    oldPassword: [
                        { required: true, message: '请输入原登录密码', trigger: ['change', 'blur'] }
                    ],
                    password: [
                        { required: true, message: '请输入登录密码', trigger: ['change', 'blur'] },
                        { min: 8, max: 20, message: '密码长度为8-20', trigger: ['change', 'blur'] },
                        { validator: validatePass, trigger: ['change', 'blur'] },
                    ],
                    confirmPassword: [
                        { validator: validatePass2, trigger: ['change', 'blur'] },
                    ],
                },captchaForm: {
                    captchaValue: '',
                    captchaImg: '',
                    error: ''
                }
            }
        },
        methods: {
            accountInput(name = 'input', type = 'focus') {
                const self = this;
                self.inputFocus[name] = type == 'focus' ? true : false;
            },
            openVerifyCode() {
                const self = this;
                var username = self.registerForm.username;
                if(!/^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/.test(username)){
                    this.$message({
                        message: '请输入11位手机号码',
                        type: 'error'
                    });
                    return;
                }

                self.captchaBoxVisible = true;
                self.changeCaptcha();

            },
            changeCaptcha() {
                const self = this;
                self.captchaForm.captchaValue = '';
                self.captchaForm.captchaImg = window.settings.api_url + "utility/captcha/get?math=" + Math.random();
            },
            checkCaptcha() {
                const self = this;
                if(self.captchaForm.captchaValue.length != '5'){
                    self.captchaForm.error = '请输入正确的图形验证码';
                }else{
                    axios.post(window.settings.api_url + 'utility/captcha/check', {
                        captcha: self.captchaForm.captchaValue
                    }).then(function(response){
                        var data = response.data;
                        if (data.error == 0){
                            self.captchaBoxVisible = false;
                            self.registerForm.sendSmsBtn = -1;
                            self.sendSms();
                        }else{
                            self.captchaForm.error = data.result.message;
                            return;
                        }
                    })
                }
            },
            onSubmit(form){
                const self = this;
                self.$refs[form].validate((valid) => {
                    if (valid) {
                        self.submitLoading = true;
                        self.$axios.post(window.settings.api_url + 'index/account/password', {
                            telephone: self.$store.state.account,
                            old_password: self.registerForm.oldPassword,
                            password: self.registerForm.password,
                        }).then(function(response){
                            self.submitLoading = false;
                            var data = response.data;
                            if (data.error == 0){
                                self.$message({
                                    message: data.result.message,
                                    type: 'success',
                                    duration: 1000,
                                    onClose: function () {
                                        self.$router.push("/account/login");
                                    }
                                });
                            }else if (data.error == 1){
                                self.registerForm.sendSmsBtn = 1;
                                self.$alert('该手机未注册，请先注册', '提示', {
                                    confirmButtonText: '确定',
                                    center: true
                                });

                            }else{
                                self.$message.error(data.result.message);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            setEndTime(){
                const self = this;
                self.registerForm.smsTime = 60;
                self.registerForm.sendSmsBtn = 0;
                let clock = window.setInterval(() => {
                    self.registerForm.smsTime--;
                    if (self.registerForm.smsTime <= 0) {
                        self.registerForm.sendSmsBtn = 1;
                        window.clearInterval(clock)
                    }
                },1000)
            }
        }
    }
</script>

<style scoped>

</style>